import React from "react";

interface ConversationItem{
   conversation_session_id:string,
   message:string 
}
export interface SessionData{
    today:ConversationItem[],
    yesterday:ConversationItem[],
    last_7_days: ConversationItem[];
}
export interface NavItem {
    key: string;
    title: string;
    disabled: boolean;
    subNavItems: {
      key: string;
      title: string;
    }[];
  }

export const transformedNavItems=(data:SessionData):NavItem[]=>{
    const sections = ["today", "yesterday", "last_7_days"];
    return sections.map((sectionKey) => ({
        key: sectionKey,
        title: sectionKey
          .split("_")
          .map((word) => word[0].toUpperCase() + word.slice(1))
          .join(" "),
        disabled: data[sectionKey as keyof SessionData].length === 0,
        subNavItems: data[sectionKey as keyof SessionData].map((item) => ({
          key: item.conversation_session_id,
          title: item.message,
        })),
      }));

}